import { useTheme } from "@mui/material";

export function JobExperienceModal({ jobExperience, setJobExperience }) {
  const theme = useTheme()
  return (
    <div className="flex flex-col px-5 sm:px-14 py-9">
        <label className="font-bold" style={{ backgroundColor: theme.palette.primary.main, color: theme.palette.text.main, borderColor: theme.palette.secondary.v3 }}
        >
          Minimum Job Experience Required in Years
        </label>
        <input
          type="number"
          min="0"
          value={jobExperience}
          onChange={(e) => {
            const input = e.target.value;
            if (/^\d*$/.test(input)) {
              setJobExperience(input);
            }
          }}
          aria-label="Enter the number of years of required experience"
          placeholder="Enter the number of years of required experience"
          className="w-full mt-3 p-2 border rounded-md"
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.text.dark,
            borderColor: theme.palette.secondary.v4,
          }}
        />
    </div>
  );
}
